import "./App.css";
import Home from "./component/screen/home";

function App() {
	return (
		<div className="App">
			<Home />
		</div>
	);
}

export default App;
